const featuresToGetGeometry = features => {
  return features.map(ft => {
    if (ft.geometry.type === 'Polygon') {
      return {
        ...ft,
        geometry: {
          type: 'MultiPolygon',
          coordinates: [ft.geometry.coordinates]
        }
      };
    }

    return ft;
  });
};

export default featuresToGetGeometry;
